import { useState } from "react";
import { saoPauloDateKey } from "./futureFollowUpGuard.mjs";

export default function NextContactDiagnostics() {
  const [open, setOpen] = useState(false);
  const [date, setDate] = useState(saoPauloDateKey());
  const [report, setReport] = useState(null);
  const [error, setError] = useState("");
  const load = async day => {
    setError("");
    try {
      const response = await fetch(`/api/crm/next-contact-blocks?date=${day}`, { credentials:"include" });
      if (!response.ok) throw new Error("Não consegui consultar os registros.");
      setReport(await response.json());
    } catch (failure) { setError(failure.message); }
  };
  return <div style={{ margin:12, background:"#fff", padding:14, borderRadius:10 }}>
    <button onClick={() => { setOpen(!open); if (!open) void load(date); }}>Registros da trava de próximo contato</button>
    {open && <div>
      <p>Somente motivo, loja e tela. Sem nomes ou telefones.</p>
      <input aria-label="Data dos registros da trava" type="date" value={date} onChange={e => { setDate(e.target.value); void load(e.target.value); }} />
      <button onClick={() => load(date)}>Atualizar</button>
      {error && <p role="alert">{error}</p>}
      {report && <><p>{report.total} ocorrências</p><table><thead><tr><th>Loja</th><th>Tela</th><th>Motivo</th><th>Ocorrências</th></tr></thead><tbody>
        {report.groups.map(g => <tr key={`${g.storeId}-${g.screen}-${g.reason}`}><td>{g.storeId}</td><td>{g.screen}</td><td>{({ empty_date:"Campo vazio", past_date:"Data passada", invalid_date:"Data inválida", save_failed:"Falha ao salvar" })[g.reason]}</td><td>{g.count}</td></tr>)}
      </tbody></table></>}
    </div>}
  </div>;
}
